import { render } from "./CadastroTipoClienteView.vue?vue&type=template&id=5b3e576a"
import script from "./CadastroTipoClienteView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoClienteView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__